import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import DesignvendorFilterCriteria from './DesignvendorFilterCriteria'
import DesignvendorList from './DesignvendorList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './DesignvendorAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setDesignvendorDashboardDesignvendorList } from '../../store/slice/PharmaSlice';

export default function DesignvendorListView({setShowEdit,setDesignvendorId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.designvendorDashboard);   

    const [filteredDesignvendorList, setFilteredDesignvendorList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { designvendorDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (designvendorDashboard.designvendorList.length>-1){
        setFilteredDesignvendorList(designvendorDashboard.designvendorList);
        transformToCardFormat(designvendorDashboard.designvendorList, setCardList);
      }
    },[designvendorDashboard.designvendorList])

    useEffect(()=>{
          transformToCardFormat(filteredDesignvendorList, setCardList);
      },[filteredDesignvendorList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.email==='' ){
            setFilteredDesignvendorList(designvendorDashboard.designvendorList);
            transformToCardFormat(designvendorDashboard.designvendorList, setCardList);

        } else {
            setFilteredDesignvendorList(
                designvendorDashboard.designvendorList
                    
                
            )
            

            //transformToCardFormat(designvendorDashboard.filteredDesignvendorList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <DesignvendorList
                    setShowEdit={setShowEdit}
                    setDesignvendorId = {setDesignvendorId}
                    tableList={filteredDesignvendorList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}